module.exports = __webpack_public_path__ + "static/example-apps-971f57685ff1af39fb286742a178eaae.png";